<template>
  <!--按键参数组件-->
  <div id="KeyConfigParam">
    <el-card style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
          <el-row>
            <el-col :span="24">
              <el-badge v-for="(item,index) in BtnConfigList" :key="index" :value="item.sort" class="item" type="primary" style="margin-top:10px;">
                <el-button v-if="item.sort != null"  @click="loadKv(item.keyConfigId)" size="small">{{item.beverageName?item.beverageName:'按键-'+item.sort}}</el-button>
                <el-button v-if="item.sort == null"  @click="loadKv(item.keyConfigId)" size="small">{{$t('stc.theKeyHasBeenDeleted')}}</el-button>
              </el-badge>
            </el-col>
          </el-row>
        </el-card>
        <el-card  v-if="showEditBtnConfigDiag"  v-loading="btnLoading" :element-loading-text="$t('equipmentmanagement.loading')+'...'" style="margin-top:10px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
          <div class="btnclass-right">
            <!-- <el-button class="item" size="small" type="primary" icon="el-icon-plus" v-if="isAdmin" @click="addBtnShow()"></el-button> -->
            <el-button class="item" size="small" type="primary" icon="el-icon-refresh" @click="refreshbtnData()">{{$t('refresh')}}</el-button>
            <el-button class="item" size="small" type="primary" icon="el-icon-upload" @click="readData()">{{$t('equipmentmanagement.read')}}</el-button>
          </div>
          <el-form style="margin:0px 10px 10px 0px;" class="ChineseForm">
            <el-row :gutter="24" >
              <el-col :span="5"><div style="text-align: left;!important">
                <span style="font-size:15px;font-weight:bold"><i class="el-icon-paperclip"></i> {{$t('equipmentmanagement.editKeySettings')}}</span>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;">
              <el-col :span="18" :offset="3"><div>
                <el-form-item :label="$t('keyNumber')+'：'" label-width="140px">
                  <el-input  class="editDiaInput" v-model="Btnsort" :placeholder="Btnsort" :disabled="true"></el-input><span style="margin-left:5px"></span>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;">
              <el-col :span="18" :offset="3"><div>
                <el-form-item :label="$t('beverageName')+'：'" label-width="140px">
                  <el-input class="editDiaInput" v-model="drinkName" ></el-input>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;">
              <el-col :span="18" :offset="3"><div>
                <el-form-item :label="$t('englishName')+'：'" label-width="140px">
                  <el-input class="editDiaInput" v-model="englishName" :placeholder="englishName" ></el-input>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;">
              <el-col :span="18" :offset="3"><div>
                <el-form-item :label="$t('price')+'：'" label-width="140px">
                  <el-input class="editDiaInput" v-model="price" :placeholder="price"  oninput="value=value.replace(/(^\.|[^\d\.])/g,''). replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^([^1])(\d)\d*/, '$1$2').replace(/^1\d{2,}.*/,'100')"  maxLength='6'></el-input><span style="margin-left:5px">{{$t('yuan')}}</span>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;display:none">
              <el-col :span="18" :offset="3"><div>
                <el-form-item :label="$t('equipmentmanagement.open')+'/'+$t('equipmentmanagement.close')+'：' " label-width="140px">
                  <el-input class="editDiaInput" v-model="openOrCloseTag" placeholder="1" oninput="value=value==0?0:1" maxLength='1'></el-input><span style="margin-left:5px">(0{{$t('equipmentmanagement.close')}}1{{$t('equipmentmanagement.open')}})</span>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;" cl>
              <el-col :span="18" :offset="3">
                <div>
                  <el-form-item :label="$t('image')+'：'" label-width="140px">
                    <PictureLibrary @choose-img="chooseRawMaterialImg" :filecatalog="7" style="display: block;float: left;"></PictureLibrary>
                    <div style="width: 150px;height: 150px;position: relative;float: left"  v-if="addData.picture" >
                      <i class="el-icon-close font-class" style="position: absolute;right: 0" @click="deleteImg"></i>
                      <img style="width:150px;height:150px" :src="addData.picture.path" fit="fill"/>
                    </div>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;" :class="$i18n.locale=='zh'?'chineseRow':'englishRow'">
              <el-col :span="21" :offset="1"><div v-for="(v,index) in BtnKNVConfigList" :key="index" style="margin: 12px 0px 22px 0px;">
                <span v-bind:value="v.name" style="display:inline-block;width:120px;text-align:right">{{v.name}}:&nbsp;</span>
                <el-input style="width:10%"
                          type="number"
                          :controls="false"
                          v-model.value="v.value">
                </el-input><span style="margin-left:10px">&nbsp;</span>
                <span v-if="isAdmin">{{$t('variableName')}}： </span>
                <el-input  style="width:15%" v-if="isAdmin" v-model="v.variableName"></el-input><span style="margin-left:10px">&nbsp;</span>
                <span v-if="isAdmin">{{$t('multiple')}}：</span>
                <el-input  style="width:10%" v-if="isAdmin" v-model="v.multiple"></el-input><span style="margin-left:10px">&nbsp;</span>
                <span >{{$t('stc.remark')}}：</span>
                <el-input  style="width:15%" v-model="v.introduction" :readonly="isAdmin?false:true" :class="!isAdmin?'onlyRead':''"></el-input><span style="margin-left:10px">&nbsp;</span>
                <el-button type="danger" icon="el-icon-delete" circle v-if="isAdmin" @click="deleteBtnKNVParam(v.id)"></el-button>
              </div></el-col>
              <el-col :span="21" :offset="1"><div v-for="(v,index) in btnList" :key="index"  style="margin: 12px 0px 22px 0px;">
                <span v-bind:value="v.name" style="display:inline-block;width:120px;text-align:right">{{v.name}}:&nbsp;</span>
                <el-input style="width:15%" type="number"
                  :controls="false"
                  size="mini" v-model.value="v.value" ></el-input><span style="margin-left:10px">
                &nbsp;</span>
                <span v-if="isAdmin">{{$t('variableName')}}： </span>
                <el-input  style="width:15%" v-model="v.variableName"></el-input><span style="margin-left:10px">&nbsp;</span>
                <span v-if="isAdmin">{{$t('multiple')}}：</span>
                <el-input  style="width:10%" v-if="isAdmin" v-model="v.multiple"></el-input><span style="margin-left:10px">&nbsp;</span>
                <span >{{$t('stc.remark')}}：</span>
                <el-input  style="width:15%" v-model="v.introduction"></el-input><span style="margin-left:10px">&nbsp;</span>
                <el-button type="danger" icon="el-icon-delete" circle @click="deleteBtnfakeParam(index)"></el-button>
              </div></el-col>
            </el-row>
          </el-form>
          <div style="text-align: right;">
            <el-button type="primary" style="margin-left: 50px;color: #eceeef;background-color: #315a7d;" @click="addBtnParam" v-if="isAdmin"  v-preventReClick>{{$t('stc.newAddedParameter')}}</el-button>
            <el-button type="primary" style="margin-right: 20px;color: #eceeef;background-color: #315a7d;" @click="addBtnConfig(true)"  v-preventReClick>{{$t('confirm')}}</el-button>
          </div>
        </el-card>
        <el-card  v-if="showBtnConfigDiag" style="margin-top:10px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
          <el-form style="margin:0px 10px 10px 0px;">
            <el-row :gutter="24" >
              <el-col :span="5"><div style="text-align: left;!important">
                <span style="font-size:15px;font-weight:bold"><i class="el-icon-paperclip"></i>{{$t('stc.newAddedKeySetting')}}</span>
              </div></el-col>
            </el-row>
            <el-steps :active="active" finish-status="success" style="margin: 28px">
              <el-step :title="$t('stc.step1')"></el-step>
              <el-step :title="$t('stc.step2')"></el-step>
              <!-- <el-step title="步骤 3"></el-step> -->
            </el-steps>
            <el-row :gutter="24" style="text-align: left;" v-if="active ==0">
              <el-col :span="18" :offset="6"><div>
                <el-form-item :label="$t('keyNumber')+'：'" label-width="130px">
                  <el-input  class="editDiaInput" v-model="Btnsort" ></el-input><span style="margin-left:5px"></span>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;" v-if="active ==0">
              <el-col :span="18" :offset="6"><div>
                <el-form-item :label="$t('beverageName')+'：'" label-width="130px">
                  <el-input class="editDiaInput" v-model="drinkName" ></el-input>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;"  v-if="active ==0">
              <el-col :span="18" :offset="6"><div>
                <el-form-item :label="$t('englishName')+'：'" label-width="130px">
                  <el-input class="editDiaInput" v-model="englishName" :placeholder="englishName" ></el-input>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;" v-if="active ==0">
              <el-col :span="18" :offset="6"><div>
                <el-form-item :label="$t('price')+'：'" label-width="130px">
                  <el-input class="editDiaInput" v-model="price"  oninput="value=value.replace(/(^\.|[^\d\.])/g,''). replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^([^1])(\d)\d*/, '$1$2').replace(/^1\d{2,}.*/,'100')"  maxLength='6'></el-input><span style="margin-left:5px">元</span>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;" v-if="active ==0">
              <el-col :span="18" :offset="6"><div>
                <el-form-item :label="$t('image')+'：'" label-width="130px">
                  <PictureLibrary @choose-img="chooseRawMaterialImg" :filecatalog="7" style="display: block;float: left;"></PictureLibrary>
                  <div style="width: 150px;height: 150px;position: relative;float: left"  v-if="addData.picture" >
                    <i class="el-icon-close font-class" style="position: absolute;right: 0" @click="deleteImg"></i>
                    <img style="width:150px;height:150px" :src="addData.picture.path" fit="fill"/>
                  </div>
                </el-form-item>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;margin-top:20px" v-if="active ==1" >
              <el-col :span="18" :offset="3"><div v-for="(v,index) in btnList" :key="index"  style="margin: 12px 0px 22px 0px;">
                <span v-bind:value="v.name" style="display:inline-block;width:120px;text-align:right">{{v.name}}:&nbsp;</span>
                <el-input class="editDiaInput" v-model="v.value"></el-input><span style="margin-left:10px">&nbsp;</span>
                <span >{{$t('variableName')}}： </span>
                <el-input class="editDiaInput" v-model="v.variableName"></el-input><span style="margin-left:10px">&nbsp;</span>
                <el-button type="danger" icon="el-icon-delete" circle @click="deleteBtnfakeParam(index)"></el-button>
              </div></el-col>
            </el-row>
            <el-row :gutter="24" style="text-align: left;" v-if="active ==2">
              <el-col :span="18" :offset="10"><div>
                <span style="font-size:25px;font-weight:bold;color: #7ec35f;">{{$t('operationSucceeded')}}!</span>
              </div></el-col>
            </el-row>
          </el-form>
          <div style="text-align: right;">
            <el-button type="primary"  v-if="active ==1" style="margin-left: 50px;color: #eceeef;background-color: #315a7d;" @click="addBtnParam"  v-preventReClick>{{$t('stc.newAddedParameter')}}</el-button>
            <el-button type="primary"  v-if="active ==0" style="margin-right: 20px;color: #eceeef;background-color: #315a7d;" @click="nextStep1()">{{$t('stc.nextStep')}}</el-button>
            <el-button type="primary"  v-if="active ==1" style="margin-right: 20px;color: #eceeef;background-color: #315a7d;" @click="addBtnConfig(false)" v-preventReClick>{{$t('ok')}}</el-button>
          </div>
        </el-card>
  </div>
</template>

<script>
import PictureLibrary from "../../components/PictureLibrary";

export default {
  name: "KeyConfigParam",
  props:{
    initValue:null
  },
  components:{
    PictureLibrary
  },
  data(){
    return{
      BtnConfigList:[],
      isAdmin:false,
      showEditBtnConfigDiag:false,
      showBtnConfigDiag:false,
      BtnKNVConfigList:[],
      Btnsort:0,
      drinkName:'',
      price:0,
      englishName:'',
      openOrCloseTag:1,
      addData:{},
      btnList:[],
      btnLoading:false,
      equipmentTypeId:0,
      kvCache: {} // 用于缓存已查询过的按键详情
    }
  },
  created() {
    this.isAdmin = this.$account.data.isAdmin
    this.loadBtnSimpleList()
  },
  methods:{
    // 获取简化的按键列表 (ID + Sort)
    async loadBtnSimpleList() {
      let that = this;
      await this.$httpservice.get("api/ecs/equipment/keyNumbers", {
        equipmentId: that.initValue.id,
        isSimple: true // 假设后端支持此参数返回简化数据
      }).then(
        function (data) {
          if (data.body.code === 200) {
            that.BtnConfigList = data.body.data.sort(that.sortBy('sort'));
          } else {
            that.$message.error(data.body.msg);
          }
        },
        function (data) {
          that.$message.warning(that.$t('queryFailedStatusCode') + data.status);
        }
      );
    },

    // 按keyConfigId查询详情，包括value pair
    async loadKv(keyConfigId){

      //console.log("按键",keyConfigId)
      let that = this;

      // 1. 检查缓存
      if (this.kvCache[keyConfigId]) {
        //console.log("从缓存加载按键详情:", keyConfigId);
        this.showEditBtnConfig(this.kvCache[keyConfigId]);
        return;
      }

      this.btnLoading = true;
      // 2. 缓存中没有，从数据库查询
      await this.$httpservice.get("api/ecs/equipment/getById/" + keyConfigId).then(
        function (data) {
          if (data.body.code === 200) {
            const detail = data.body.data;
            // 3. 存入缓存
            that.kvCache[keyConfigId] = detail;
            // 4. 显示信息
            that.showEditBtnConfig(detail);
          } else {
            that.$message.error(data.body.msg);
          }
          that.btnLoading = false;
        },
        function (data) {
          that.$message.warning(that.$t('queryFailedStatusCode') + data.status);
          that.btnLoading = false;
        }
      );
    },

    //获取按键信息
    async loadBtnConfigList(){
      // this.menuConfigDialogVisible = true;
      let that = this;
      await this.$httpservice.get("api/Equipment/KeyConfigs",{dtuNo:that.initValue.dtuNumber}).then(
        function (data) {
          if(data.body.code=="200"){
            that.BtnConfigList = data.body.data;

            that.totalBtnConfigCount = data.body.totalCount;
          }else{
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },
        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },

    // 点击按键时的处理逻辑
    async handleKeyClick(item) {
      this.btnLoading = true;
      let that = this;
      // 1. 先获取该按键的完整详细信息 (Name, Price, EnglishName, FileLib 等)
      await this.$httpservice.get("api/Equipment/KeyConfigs", {
        id: item.id,
        dtuNo: that.initValue.dtuNumber
      }).then(
        function (data) {
          if (data.body.code == "200") {
            const fullConfig = data.body.data[0] || data.body.data; // 适配返回数组或对象的情况
            // 2. 调用原有的显示编辑逻辑
            that.showEditBtnConfig(fullConfig);
          } else {
            that.$message.error(data.body.msg);
            that.btnLoading = false;
          }
        },
        function (data) {
          that.$message.warning(that.$t('queryFailedStatusCode') + data.status);
          that.btnLoading = false;
        }
      );
    },
    //加载按键键值对
    loadBtnKNVConfig(id){
      this.btnLoading = true;
      let that = this
      // 取出按键中id相对的对象的FileLib对象,然后赋值到fileList中
      that.fileList = [] // 清空列表

        this.$httpservice.get("api/Equipment/GetKeyConfigValuePairs?keyConfigId="+id).then(
          function (data) {
            if(data.body.code=="200"){
              that.BtnKNVConfigList = data.body.data.sort(that.sortBy('sort'));
              that.totalBtnKNVConfigCount = data.body.totalCount;
              that.btnLoading = false;
            }else{
              that.$message({
                message: data.body.msg,
                type: 'danger'
              })
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      //}
    },
    //删除提示弹窗
    openDeleteBtnDialog(id){
      let that = this
      this.$confirm(that.$t('equipmentmanagement.thisOperationWillPermanentlyDeleteThisKey'), that.$t('tips'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.closeDeleteBtn(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('equipmentmanagement.deletionCancelled')
        });
      });
    },
    //显示编辑按键窗口
    showEditBtnConfig(e){
      // 清空图片
      this.addData = new Object()
      // 设置图片信息 (从完整对象 e 中获取)
      if (e.fileLibID) {
        this.addData.picture_Id = e.fileLibID
        this.addData.picture = e.fileLib
      }

      this.btnList=[];
      this.showBtnConfigDiag = false;
      this.showEditBtnConfigDiag = true;
      this.btnid = e.id
      this.Btnsort = e.sort;
      this.drinkName = e.name;
      this.price = e.price;
      this.openOrCloseTag = e.openOrCloseTag;
      this.englishName = e.englishName;

      // 如果数据中已经包含了键值对，则直接使用，否则再查一次
      if (e.keyConfigValuePairs && e.keyConfigValuePairs.length > 0) {
        this.BtnKNVConfigList = e.keyConfigValuePairs.sort(this.sortBy('sort'));
      } else {
        this.loadBtnKNVConfig(this.btnid);
      }
    },
    //显示编辑按键窗口
    addBtnShow(){
      this.active = 0;
      this.btnList=[]
      this.showBtnConfigDiag = true;
      this.showEditBtnConfigDiag = false;
      this.Btnsort = 0;
      this.drinkName = '',
        // this.openOrCloseTag = 0;
        // this.cupAmountFineAdjustment = 0;
        this.price = 0;
      this.addData = new Object()

    },
    //新增按键参数
    addBtnParam(){
      this.$prompt(this.$t('stc.pleaseEnterTheParameterName'), this.$t('tips'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('ok'),
        inputErrorMessage: this.$t('equipmentmanagement.incorrectParameterName')
      }).then(({ value }) => {
        let nowsort = this.BtnKNVConfigList.length + this.btnList.length + 1
        this.btnList.push({name: value, value : '',variableName:'',multiple:1,sort:nowsort,introduction:''});
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('cancelInput')
        });
      });
    },
    //数组属性排序
    sortBy(attr, rev = true) {
      rev = rev ? 1 : -1
      return function(a,b){
        a = a[attr];
        b = b[attr];
        if(a > b){
          return rev * 1
        }
        else if(a < b){
          return rev * -1
        }
        return 0
      }
    },
    //按键设置
    addBtnConfig(flag){
      let that = this;
      // 编辑
      if(flag){
        if(this.Btnsort){
          let putData = new Object();

          // putData.id = this.btnid;
          // putData.equipment_ID = parseInt(this.initValue.id);
          putData.price = this.price*1;
          putData.name = this.drinkName;
          putData.sort = parseInt(this.Btnsort);
          putData.openOrCloseTag = parseInt(this.openOrCloseTag);
          putData.englishName = this.englishName;
          putData.keyConfigID = parseInt(this.btnid);
          putData.keyConfigValuePairs=[]
          this.btnList = this.btnList.concat(this.BtnKNVConfigList)
          this.btnList.sort(this.sortBy('sort'))
          for(let i=0;i<this.btnList.length;i++){
            let sortnow = i + 1
            let current = this.btnList[i]
            // 判断是否超出上下限
            if(!(current.maxValue==0 && current.minValue==0)){
              // 不能小于最小值
              if(current.value < current.minValue){
                this.$message.error("["+current.name+"]的值不能小于最小值"+current.minValue)
                this.btnList=[];
                return
              }else if(current.value > current.maxValue){
                this.$message.error("["+current.name+"]的值不能大于最大值"+current.maxValue)
                this.btnList=[];
                return
              }
            }
            putData.keyConfigValuePairs.push({
              id: current.id,
              name: current.name,
              value: current.value,
              variableName: current.variableName,
              multiple: current.multiple,
              sort: sortnow,
              introduction: current.introduction,
              maxValue: current.maxValue,
              minValue: current.minValue
            })
          }
          this.btnList=[];
          // 图片只会是有，或者没有，有就存id，没有就不存
          putData.fileLibID = this.addData.picture_Id?this.addData.picture_Id:null
          this.$httpservice.post("api/Equipment/SyncKeyConfig",putData).then(
            function (data) {
              if(data.body.code=="200"){
                that.$message({
                  message: that.$t('equipmentmanagement.modifyTheKeyConfigurationSuccessfully'),
                  type: 'success'
                });
                that.noticTwoFunc()
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
            }
          )
        }else{
          this.$message({
            message: this.$t('equipmentmanagement.pleaseCompleteTheConfigurationInformation'),
            type: 'warning'
          });
        }
      }
      //新增
      else{
        if(this.Btnsort !=null){
          let postData={
            keyConfigValuePairPostDatas:[],
            keyConfig_ID:0
          };
          postData.keyConfig_ID = parseInt(this.keyconfig.id);
          this.btnList.forEach(e=>{
            postData.keyConfigValuePairPostDatas.push({name:e.name,value:e.value,variableName:e.variableName,multiple:e.multiple,sort:e.sort,introduction:e.introduction})
          })

          // postData.cupType_ID = this.selectedCupTypeList[0].id;
          let that = this;
          this.$httpservice.post("api/Equipment/BatchAddKeyConfigValuePair",postData).then(
            function (data) {
              if(data.body.code=="200"){
                that.$message({
                  message: that.$t('stc.newlyAddKeyConfigurationSuccessfully'),
                  type: 'success'
                });
                that.loadBtnSimpleList();
                that.btnList=[];
                if (that.active++ > 2) that.active = 0;
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
            }
          );
        }else{
          this.$message({
            message: this.$t('equipmentmanagement.pleaseCompleteTheConfigurationInformation'),
            type: 'warning'
          });
        }
      }
    },
    // 同步调用，防止获取键值对时没有加载完按键信息
    async noticTwoFunc(){
      await this.loadBtnSimpleList()
      if (this.btnid) {
        // 保存成功后清除缓存，确保下次点击或刷新时获取最新数据
        delete this.kvCache[this.btnid];
        this.loadKv(this.btnid);
      }
    },
    chooseRawMaterialImg(e){
      if(e){
        this.addData.picture=e;
        this.addData.picture_Id=e.id;
        this.$forceUpdate();
      }
    },
    // 删除已选择的图片
    deleteImg(){
      // 此时的删除对象就是addData对应的图片
      this.addData = {}
    },
    //新增按键设置第一步--下一步
    nextStep1(){
      let that = this;
      this.$httpservice.post("api/Equipment/AddKeyConfig",{sort:parseInt(that.Btnsort),name:that.drinkName,equipment_ID:parseInt(that.initValue.id),price:that.price,englishName:that.englishName,fileLibID:that.addData?that.addData.picture_Id:null}).then(
        function (data) {
          if(data.body.code=="505"){
            that.$message({
              message: that.$t('equipmentmanagement.keyNumberAlreadyExists'),
              type: 'warning'
            });
          }else if(data.body.code=="200"){
            that.$message({
              message: that.$t('stc.addNewKeySuccessfully'),
              type: 'success'
            })
            that.keyconfig = data.body.data;
            that.loadBtnSimpleList();
            if (that.active++ > 2) that.active = 0;
          }
          else
          {
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },
        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },
    //删除按键键值对
    deleteBtnKNVParam(id){
      let that = this;
      this.$httpservice.delete("api/Equipment/DeleteKeyConfigValuePair?KeyConfigValuePairId="+id).then(
        function (data) {
          if(data.body.code=="200"){
            that.$message({
              message: that.$t('deleteSuccessfully'),
              type: 'success'
            });
            if (that.btnid) {
              delete that.kvCache[that.btnid];
              that.loadKv(that.btnid);
            }
          }else{
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },
        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },
    //按键配置参数前端假删除
    deleteBtnfakeParam(index,list){
      this.btnList =  this.btnList.slice(0, index).concat(this.btnList.slice(index + 1,this.btnList.length))
    },
    //设备参数前端假删除
    deletefakeParam(index){
      this.list =  this.list.slice(0, index).concat(this.list.slice(index + 1,this.list.length))
    },
    //新增按键键值对
    addBtnKNVConfig(){
      if(this.btnList.length > 0 || this.BtnKNVConfigList.length>0){

        this.BtnKNVConfigList.forEach((e,index)=>{
          this.btnList.push({name:e.name,value:e.value,variableName:e.variableName,multiple:e.multiple,sort:index+1,introduction:e.introduction})
        })

        let that = this;
        this.$httpservice.post("api/Equipment/BatchAddKeyConfigValuePair",{keyConfigValuePairPostDatas:that.btnList,keyConfig_ID:that.btnid}).then(
          function (data) {
            if(data.body.code=="200"){
              that.$message({
                message: that.$t('equipmentmanagement.newlyAddKeyParameterConfigurationSuccessfully'),
                type: 'success'
              });
              if (that.btnid) {
                delete that.kvCache[that.btnid];
                that.loadKv(that.btnid);
              }
              that.btnList = [];

            }else{
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      }else{
        this.$message({
          message: this.$t('equipmentmanagement.pleaseCompleteTheConfigurationInformation'),
          type: 'warning'
        });
      }
    },
    //通知设备读取
      readData(){
        this.btnLoading = true
        this.$httpservice.get('api/EquipmentOperation/PushKeyConfigParameter',{equipmentId:this.initValue.id,keySort:this.Btnsort}).then(result => {
          if(result.data.code=='200'){
            setTimeout(() => {
              this.btnLoading = false
              this.$message.success(this.$t('equipmentmanagement.readingSuccessfully'))
              this.refreshbtnData()
            }, 10000);
          }else{
            this.$message.error(this.$t('equipmentmanagement.readFailure'))
          }
        })
      },
    //刷新按键数据
    refreshbtnData(){
       if (this.btnid) {
         delete this.kvCache[this.btnid];
         this.loadKv(this.btnid);
       }
    },
  },
}
</script>

<style lang="less">
  #KeyConfigParam{
    .font-class{
      font-size:20px;
    }
    .editDiaInput{
      width: 30%;
      margin: 0 0 0 0px;
    }
    .item {
      margin-top: 10px;
      margin-right: 20px;
    }
    .btnclass-right{
      display: inline-block;
      position: absolute;
      vertical-align: middle;
      /* float: right; */
      right: 10px;
      margin-top: 10px;
      z-index: 9;
    }
    .grayClass{
      background-color: #DCDCDC	;
    }
    .normalClass{
      background-color: #FFFFFF;
    }
    .mini_coffee{
      background-color:#855E42;
      color: #ffffff;
    }
    .mini_coffee_click{
      background-color:#8B4513;
      color: #ffffff;
    }
  }
  .chineseRow{
    span{
      font-size: 15px!important;
    }
  }
  .englishRow{
    span{
      font-size: 12px!important;
    }
  }
  .onlyRead{
    input{
      background-color: #d0d0d0!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/KeyConfigParam.vue